import SectionStyled, { TableCustomProps } from './styles';

export default function Table<T = {}>({ ...props }: TableCustomProps<T>) {
  // @ts-ignore
  return <SectionStyled pagination={false} {...props} tableLayout={'fixed'} />;
}
